import { isValidPhoneNumber } from 'libphonenumber-js'
import { z } from 'zod'

const requiredMessage = 'Required'

const emailFormat = z.string().email()

export const SchedulePickupSchema = z
  .object({
    address1: z.string(),
    address2: z.string(),
    addressType: z.enum(['default', 'different']),
    city: z.string(),
    company: z.string(),
    country: z.string(),
    earliestTime: z.string().min(1),
    email: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    latestTime: z.string(),
    phone: z.string(),
    pickupDate: z.string().min(1),
    pointOfPickup: z.string(),
    postalCode: z.string(),
    specialInstructions: z.string().optional(),
    state: z.string(),
  })
  .superRefine((data, ctx) => {
    if (data.addressType === 'different') {
      const required: Array<keyof typeof data> = [
        'firstName',
        'lastName',
        'company',
        'address1',
        'city',
        'state',
        'postalCode',
        'country',
      ]
      required.forEach(field => {
        if (!data[field]) {
          ctx.addIssue({ code: z.ZodIssueCode.custom, path: [field], message: requiredMessage })
        }
      })

      if (!data.phone) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['phone'], message: requiredMessage })
      } else if (!isValidPhoneNumber(data.phone, 'US')) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['phone'],
          message: 'Please enter a valid phone number.',
        })
      }

      if (!data.email) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['email'], message: requiredMessage })
      } else if (!emailFormat.safeParse(data.email).success) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['email'],
          message: 'Must be a valid email',
        })
      }
    }

    if (data.latestTime && data.earliestTime && !(data.latestTime > data.earliestTime)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['latestTime'],
        message: 'End time cannot be equal to or before start time',
      })
    }
  })
